import { render, staticRenderFns } from "./QLeadAllocationDataTable.vue?vue&type=template&id=0e576ac8&scoped=true&"
import script from "./QLeadAllocationDataTable.vue?vue&type=script&lang=js&"
export * from "./QLeadAllocationDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QLeadAllocationDataTable.vue?vue&type=style&index=0&id=0e576ac8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e576ac8",
  null
  
)

export default component.exports